import { render, staticRenderFns } from "./PersonalDataConsent.vue?vue&type=template&id=a4fc8012&"
import script from "./PersonalDataConsent.vue?vue&type=script&lang=js&"
export * from "./PersonalDataConsent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports